/* eslint-disable @next/next/no-img-element */
import { formatCurrency } from '@/helpers/format';
import usePrefix from '@/hooks/usePrefix';
import { useMobxStores } from '@/stores';
import {
  Button,
  Divider,
  Popover,
  Rate,
  Tabs,
} from 'antd';
import Image from 'next/image';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { useState, useEffect, useRef } from 'react';
import ButtonStatus from './ButtonStatus2';
import VerticalAPR from './FacilityHighlights/VerticalAPR';
import {
  CheckOutlined,
} from './Icons';
import SearchImage from './SearchImage';
import { isShowHighlights } from '@/helpers/highlights';
import { CDN1, CDN2 } from '@/helpers/api';
import { mapRateSearchName, mapReviewStars } from '@/utils/tools';
import { getParkingAtPath, getUrlCodeOrSlug } from '@/utils/newparkingatroutes';
import NeedMoreData from './NeedMoreData';
import { IAirport } from '@/types';
import { isServer } from '@/utils/isServer';
import { setStorageCheckinCheckout } from '@/hooks/useLocalstorage';
import { useTranslation } from 'react-i18next';
import SidePopover from './FacilityHighlights/SidePopover';

function checkShowFull(facility_url_code: string) {
  return !facility_url_code?.toLocaleLowerCase().startsWith('arv');
}

const Card = ({
  configInfo,
  item,
  index,
  cardsRef,
  checkin,
  checkout,
  hasHighlight,
  deviceType,
  isCity,
}) => {
  const prefix = usePrefix();
  const router = useRouter();
  const { searchStore } = useMobxStores();
  const [showWhatParkBtn, setShowWhatParkBtn] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<string>('description');
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false);

  const { TabPane } = Tabs;

  const openMoreInformation = async (e): Promise<void> => {
    e.preventDefault();
    setShowWhatParkBtn(!showWhatParkBtn);
    setActiveKey('description');
    return;
  };

  const openViewHighlights = async (e): Promise<void> => {
    e.preventDefault();
    setShowWhatParkBtn(!showWhatParkBtn);
    setActiveKey('highlights');
    return;
  };

  function preventClick(e) {
    if (!e) e = window.event;
    e.stopPropagation();
    return;
  }

  useEffect(() => {
    sessionStorage.removeItem('checkin');
    sessionStorage.removeItem('checkout');
  }, []);

  const UnbrandedImages = [
    CDN2() + '/staticmyapp/cards-default-image.webp',
    CDN2() + '/staticmyapp/pvd-airport.webp',
    CDN2() + '/staticmyapp/default-image-3.webp',
  ];

  let lastUnbrandedIndex = null;

  const getUnbrandedImage = () => {
    let randomIndex = index % UnbrandedImages.length;
    if (randomIndex === lastUnbrandedIndex) {
      randomIndex = (randomIndex + 1) % UnbrandedImages.length;
    }
    lastUnbrandedIndex = randomIndex;
    return UnbrandedImages[randomIndex];
  };

  let imageUrl = item.facility_is_image_uploaded
    ? `${CDN1}/upload/${configInfo.environment}/${item.facility_id}`
    : getUnbrandedImage();

  const arriveLogo = item.highlights.find((x) => x.type === 'arrive_logo_url');
  if (arriveLogo) {
    imageUrl = arriveLogo.description;
  }

  return item.date_sold_out > 0 ? (
    <>
      <div
        key={item.facility_id + index}
        ref={(el) => (cardsRef.current[index] = el)}
        className={`px-2 relative mx-auto bg-white rounded-[0.675rem] overflow-hidden  transition-all duration-300 ${item.selected ? 'shadow-2xl' : ''} opacity-60`}
      >
        {/* <div
          className="flex flex-col xl:flex-row w-full "
        >
          <div className="xl:flex-[0_0_20%] p-2">
            <div className="relative w-full h-24">
              <SearchImage
                src={imageUrl}
                native={!!arriveLogo}
                placeholder="blur"
                fill
                style={{ objectFit: 'contain' }}
                blurDataURL={getUnbrandedImage()}
                errorImage={getUnbrandedImage()}
                alt={`Airport: ${item.facility_lot} Background`}
                key={item.facility_id}
                quality={100}
                className={""}
              />
            </div>
          </div>
          <div className="w-full flex flex-col space-y-4">
            <div className="flex flex-row w-full p-4">
              <div className="flex flex-col col-span-2 px-0 self-center mx-auto w-3/5 ">
                <div className="w-full space-y-2">
                  <h3 className="text-lg font-semibold text-left w-full truncate">
                    {item.facility_lot}
                  </h3>
                  {checkShowFull(item.facility_url_code) && (
                    <div className="flex flex-row items-center gap-2">
                      <Rate
                        allowHalf
                        disabled
                        value={1}
                        count={1}
                        className='text-base'
                      />
                      <p className=" text-gray-500">
                        ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {item.facilityParkingType == 3 ||
                item.facilityParkingType == 4 ? (
                <p className="w-full text-base text-right">
                  {formatCurrency({
                    value: item.facility_solid_selling_price
                      ? item.facility_solid_selling_price
                      : item.facility_afee,
                    locale: 'en-US',
                    currency: 'USD',
                  })} {' '}
                  <small className="text-sm text-onair-gray">
                    {item.facilityParkingType == 3
                      ? 'Sleep and Park'
                      : 'Monthly Park'}
                  </small>
                </p>
              ) : (
                <p className="w-full text-base text-right">
                  {formatCurrency({
                    value: item.facility_selling_price,
                    locale: 'en-US',
                    currency: 'USD',
                  })}{' '}
                  <small className="text-sm text-onair-gray lowercase">
                    {mapRateSearchName(item)}
                  </small>
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          className={`w-full overflow-hidden flex justify-between border-t mt-2 py-2`}
        >
          <ButtonStatus
            status={searchStore.facilityStatus(item)}
            facility_url_code={item.facility_url_code}
            minDays={item.facility_min_days}
            maxDays={item.facility_max_days}
            configInfo={configInfo}
            item={item}
          />
        </div> */}
        <div
          className="flex flex-col xl:flex-row w-full gap-x-2"
        >
          {deviceType !== 'mobile' && (
            <div className="xl:flex-[0_0_20%] px-4 relative w-32 h-32">
              <SearchImage
                src={imageUrl}
                native={!!arriveLogo}
                placeholder="blur"
                fill
                style={{ objectFit: 'contain' }}
                blurDataURL={getUnbrandedImage()}
                errorImage={getUnbrandedImage()}
                alt={`Airport: ${item.facility_lot} Background`}
                key={item.facility_id}
                quality={100}
              />
            </div>
          )}

          <div className="flex flex-col xl:flex-row w-full">
            <div className="xl:flex-[1_2_auto] p-x-2 flex flex-col justify-center w-auto space-y-1">
              {deviceType === 'mobile' ? (
                <div className="flex flex-col gap-2">
                  <div className="flex flex-row items-start gap-4">
                    <div className="relative w-16 h-16">
                      <SearchImage
                        src={imageUrl}
                        native={!!arriveLogo}
                        placeholder="blur"
                        fill
                        style={{ objectFit: 'contain' }}
                        blurDataURL={getUnbrandedImage()}
                        errorImage={getUnbrandedImage()}
                        alt={`Airport: ${item.facility_lot} Background`}
                        key={item.facility_id}
                        quality={100}
                      />
                    </div>
                    <div className="flex flex-col gap-2">

                      <h3 className="text-lg font-semibold truncate max-w-[18rem]">
                        {item.facility_lot}
                      </h3>
                      {checkShowFull(item.facility_url_code) && (
                        <>
                          <div className="flex flex-row items-center gap-2">
                            <Rate
                              allowHalf
                              disabled
                              value={mapReviewStars(item.facility_review_avg)}
                              className='text-xs'
                            />
                            <p className="text-sm font-bold">
                              <span
                                className='text-xs'
                              >
                                &nbsp;{' '}
                                {item.facility_review_avg >= 4.5
                                  ? 'Excellent!'
                                  : item.facility_review_avg >= 4.0
                                    ? 'Very Good!'
                                    : 'Good!'}
                              </span>
                            </p>
                            <p className="text-xs text-gray-500">
                              ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                            </p>
                          </div>
                        </>
                      )}

                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <h3 className="text-2xl font-semibold truncate max-w-[18rem]">
                    {item.facility_lot}
                  </h3>
                  {checkShowFull(item.facility_url_code) && (
                    <div className="flex flex-row items-center gap-x-1">
                      <Rate
                        allowHalf
                        disabled
                        value={mapReviewStars(item.facility_review_avg)}
                        className='text-base'
                      />
                      <p className="text-base font-bold">
                        <span
                        >
                          &nbsp;{' '}
                          {item.facility_review_avg >= 4.5
                            ? 'Excellent!'
                            : item.facility_review_avg >= 4.0
                              ? 'Very Good!'
                              : 'Good!'}
                        </span>
                      </p>
                      <p className="text-base text-gray-500">
                        ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>

          </div>
        </div>
        <div className="flex flex-col justify-between xl:items-end text-right w-full xl:self-center border-t xl:border-none">
          <ButtonStatus
            status={searchStore.facilityStatus(item)}
            facility_url_code={item.facility_url_code}
            minDays={item.facility_min_days}
            maxDays={item.facility_max_days}
            configInfo={configInfo}
            item={item}
          />
        </div>
      </div>
    </>
  ) : (
    <div
      key={item.facility_id + index}
      ref={(el) => (cardsRef.current[index] = el)}
      className="px-2 py-4 overflow-hidden bg-white"
    >
      <div
        className="flex flex-col xl:flex-row w-full gap-x-2"
      >
        {deviceType !== 'mobile' && (
          <div className="xl:flex-[0_0_20%] px-4 relative w-32 h-32">
            <SearchImage
              src={imageUrl}
              native={!!arriveLogo}
              placeholder="blur"
              fill
              style={{ objectFit: 'contain' }}
              blurDataURL={getUnbrandedImage()}
              errorImage={getUnbrandedImage()}
              alt={`Airport: ${item.facility_lot} Background`}
              key={item.facility_id}
              quality={100}
            />
          </div>
        )}

        <div className="flex flex-col xl:flex-row w-full">
          <div className="xl:flex-[1_2_auto] p-x-2 flex flex-col justify-center w-auto space-y-1">
            {deviceType === 'mobile' ? (
              <div className="flex flex-col gap-2">
                <div className="flex flex-row items-start gap-4">
                  <div className="relative w-16 h-16">
                    <SearchImage
                      src={imageUrl}
                      native={!!arriveLogo}
                      placeholder="blur"
                      fill
                      style={{ objectFit: 'contain' }}
                      blurDataURL={getUnbrandedImage()}
                      errorImage={getUnbrandedImage()}
                      alt={`Airport: ${item.facility_lot} Background`}
                      key={item.facility_id}
                      quality={100}
                    />
                  </div>
                  <div className="flex flex-col gap-2">

                    <h3 className="text-lg font-semibold truncate max-w-[18rem]">
                      {item.facility_lot}
                    </h3>
                    {checkShowFull(item.facility_url_code) && (
                      <>
                        <div className="flex flex-row items-center gap-2">
                          <Rate
                            allowHalf
                            disabled
                            value={mapReviewStars(item.facility_review_avg)}
                            className='text-xs'
                          />
                          <p className="text-sm font-bold">
                            <span
                              className='text-xs'
                            >
                              &nbsp;{' '}
                              {item.facility_review_avg >= 4.5
                                ? 'Excellent!'
                                : item.facility_review_avg >= 4.0
                                  ? 'Very Good!'
                                  : 'Good!'}
                            </span>
                          </p>
                          <p className="text-xs text-gray-500">
                            ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                          </p>
                        </div>
                      </>
                    )}

                  </div>
                </div>
                {isShowHighlights(item.highlights) && (
                  <Popover
                    content={
                      <SidePopover
                        facility={item}
                        highlights={item.highlights}
                        size="small"
                      />
                    }
                    trigger='click'
                    overlayClassName="search-list-popover"
                  >
                    <div
                      onClick={(e) => e.stopPropagation()}
                      onTouchStart={(e) => e.stopPropagation()}
                    >
                      <VerticalAPR
                        facility={item}
                        highlights={item.highlights}
                        size="small"
                        className="flex flex-col gap-0.5 justify-center items-start"
                        airportinitials={item.airport_initials}
                        isCity={isCity}
                      />
                    </div>
                  </Popover>
                )}

              </div>
            ) : (
              <>
                <h3 className="text-2xl font-semibold truncate max-w-[18rem]">
                  {item.facility_lot}
                </h3>
                {checkShowFull(item.facility_url_code) && (
                  <div className="flex flex-row items-center gap-x-1">
                    <Rate
                      allowHalf
                      disabled
                      value={mapReviewStars(item.facility_review_avg)}
                      className='text-base'
                    />
                    <p className="text-base font-bold">
                      <span
                      >
                        &nbsp;{' '}
                        {item.facility_review_avg >= 4.5
                          ? 'Excellent!'
                          : item.facility_review_avg >= 4.0
                            ? 'Very Good!'
                            : 'Good!'}
                      </span>
                    </p>
                    <p className="text-base text-gray-500">
                      ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                    </p>
                  </div>
                )}
                {isShowHighlights(item.highlights) && (
                  <Popover
                    content={
                      <SidePopover
                        facility={item}
                        highlights={item.highlights}
                        size="small"
                      />
                    }
                    trigger="hover"
                    overlayClassName='search-list-popover-desktop'
                  >
                    <VerticalAPR
                      facility={item}
                      highlights={item.highlights}
                      size="small"
                      className="flex flex-col gap-0.5 justify-center items-start"
                      airportinitials={searchStore.airportinitials}
                      isCity={isCity}
                    />
                  </Popover>
                )}
              </>
            )}
          </div>

          <div className="flex flex-col justify-between xl:items-end text-right w-full xl:max-w-[12rem] xl:self-center border-t xl:border-none">
            {item.facilityParkingType == 3 ||
              item.facilityParkingType == 4 ? (
              <div className="flex flex-col justify-center items-end text-right gap-4 w-full">
                <div>
                  <p className="text-lg text-primary">
                    {formatCurrency({
                      value: item.facility_solid_selling_price
                        ? item.facility_solid_selling_price
                        : item.facility_afee,
                      locale: 'en-US',
                      currency: 'USD',
                    })} {' '}
                    <small className="text-lg">
                      {item.facilityParkingType == 3
                        ? 'Sleep and Park'
                        : 'Monthly Park'}
                    </small>
                  </p>
                  <p className="text-xl font-bold ">
                    {formatCurrency({
                      value: item.facility_total_price,
                      locale: 'en-US',
                      currency: 'USD',
                    })}{' '}
                    <small className="text-lg font-normal">
                      total
                    </small>
                  </p>
                </div>
                <Button
                  type="primary"
                  className="w-full xl:w-4/5"
                  size="large"
                  href={`${prefix}/${getParkingAtPath(
                    item
                  )}/${getUrlCodeOrSlug(item)}`}
                >
                  <span className="font-bold">
                    {item.facilityParkingType == 3
                      ? 'Sleep & Park'
                      : item.facilityParkingType == 4
                        ? 'Monthly Park'
                        : 'Park Here'}
                  </span>
                </Button>
                <small className="text-xs text-green-600">
                  <CheckOutlined className="mr-2" />
                  Total includes taxes and fees
                </small>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-end text-right gap-4 w-full">
                <div>
                  <p className="text-lg text-primary">
                    {formatCurrency({
                      value: item.facility_selling_price,
                      locale: 'en-US',
                      currency: 'USD',
                    })}{' '}
                    <small className="text-lg lowercase">
                      {mapRateSearchName(item)}
                    </small>
                  </p>
                  <p className="text-xl font-bold ">
                    {formatCurrency({
                      value: item.facility_total_price,
                      locale: 'en-US',
                      currency: 'USD',
                    })}{' '}
                    <small className="text-lg font-normal">
                      total
                    </small>
                  </p>
                </div>
                <Button
                  type="primary"
                  className="w-full xl:w-4/5"
                  size="large"
                  href={`${prefix}/${getParkingAtPath(
                    item
                  )}/${getUrlCodeOrSlug(item)}`}
                >
                  <span className="font-bold">
                    {item.facilityParkingType == 3
                      ? 'Sleep & Park'
                      : item.facilityParkingType == 4
                        ? 'Monthly Park'
                        : 'Park Here'}
                  </span>
                </Button>
                <small className="text-xs text-green-600">
                  <CheckOutlined className="mr-2" />
                  Total includes taxes and fees
                </small>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

function SearchListAPR({
  configInfo,
  checkin,
  checkout,
  deviceType,
  searchAlternate,
  currentAirport,
  isNewLanding,
  isCity,
  testScope,
}: {
  configInfo: any;
  checkin: string;
  checkout: string;
  deviceType: string;
  searchAlternate: any;
  currentAirport?: IAirport;
  isNewLanding?: boolean;
  isCity?: boolean;
  testScope?: any;
}) {
  const { searchStore } = useMobxStores();
  const cardsRef = useRef<any>([]);
  const { t } = useTranslation();

  const hasHighlight = searchStore.filteredFacilities?.some(
    (x) => x.facility_branded == 1
  );

  const baseFacilities =
    searchStore.filteredFacilities ?? searchAlternate?.result;


  const showLowestPriceMessage = baseFacilities?.some(
    (item) => item.facility_disable_lowest_price === 0
  );
  useEffect(() => {
    if (!isServer) {
      setStorageCheckinCheckout(checkin, checkout);
    }
  }, [checkin, checkout]);
  return (
    // <Skeleton
    //   active
    //   loading={searchStore.isLoading}
    //   className="max-w-2xl mx-auto"
    // >
    <>
      {baseFacilities?.map((item, index) => {
        return (
          <div key={index} className="mb-2">
            <Card
              configInfo={configInfo}
              item={item}
              index={index}
              cardsRef={cardsRef}
              checkin={checkin}
              checkout={checkout}
              hasHighlight={hasHighlight}
              deviceType={deviceType}
              isCity={isCity}
            />
            <Divider className="my-2 bg-[#d8d8d8]" />
          </div>
        );
      })}
      {!isNewLanding && showLowestPriceMessage && (
        <p className="text-[0.625rem] ml-2 mt-1.5 mb-4 xl:mb-2 xl:text-sm">
          {t('price_match_guarantee')}
        </p>
      )}

      {searchStore.filteredFacilities?.length === 0 && (
        <NeedMoreData airport={currentAirport} />
      )}
    </>
  );
}

export default observer(SearchListAPR);
